import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {toast} from '@ui/toast/toast';
import {DatatableDataQueryKey} from '@common/datatable/requests/paginated-resources';
import {AxiosResponse} from 'axios';
import {UseFormReturn} from 'react-hook-form';
import {RequestTitle} from '@app/titles/models/Request';
import {onFormQueryError} from '@common/errors/on-form-query-error';

export interface UpdateRequestPayload extends RequestTitle {}

interface UpdateRequestResponse {
  request: RequestTitle;
}

export function useUpdateRequest(
  requestId: number,
  form: UseFormReturn<UpdateRequestPayload>,
) {
  return useMutation({
    mutationFn: (payload: UpdateRequestPayload) =>
      updateRequest(requestId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['requests', `${requestId}`],
      });
      toast('Request updated successfully');
    },
    onError: r => onFormQueryError(r, form),
  });
}

function updateRequest(
  requestId: number,
  request: UpdateRequestPayload,
): Promise<AxiosResponse<UpdateRequestResponse>> {
  return apiClient.put<UpdateRequestResponse>(`requests/${requestId}`, request);
}
